import { ActivatedRoute } from '@angular/router';
import { isRelistPage, isCreatePage, isEditPage } from './../../../../helpers/router.helper';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { isBasePackageSelection } from 'libs/property-ui/src/lib/helpers/price.helper';
import { isAgentPage } from 'libs/property-ui/src/lib/helpers/router.helper';
import { Subject } from 'rxjs';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';
import { isNewHomeCategory } from '../../../../helpers/router.helper';
import { DEFAULT_CONTACT_SUPPORT_EMAIL } from '../../../../constants/property-promote.constants';

@Component({
    selector: 'property-summary-page-agent-summary-section',
    templateUrl: './summary-page-summary-section.component.html',
    styleUrls: ['./summary-page-summary-section.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ResidentialForSaleAgentSummaryPageSummarySectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    private _destroyed$: Subject<void> = new Subject<void>();
    hasPartnershipAgreement = false;
    isRelistPage = false;
    isEditPage = false;
    isCreatePage = false;
    paPackageSelected = false;
    isBasePackageSelectionForRelistPage: boolean;
    isNewHomeCategory = false;
    hasIncreasedRV = false;
    isAgent = false;
    priceDisplay: string;
    defaultContactSupportEmail = DEFAULT_CONTACT_SUPPORT_EMAIL;

    constructor(draftFacade: DraftFacade, private activatedRoute: ActivatedRoute) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.isRelistPage = isRelistPage(this.activatedRoute);
            this.isEditPage = isEditPage(this.activatedRoute);
            this.isCreatePage = isCreatePage(this.activatedRoute);

            this.hasPartnershipAgreement = (this.metadata.partnershipAgreementContents?.premiumPackages || []).length > 0;

            if (this.hasPartnershipAgreement) {
                const paPackageCode = this.metadata.partnershipAgreementContents.premiumPackages[0].code;

                this.paPackageSelected = this.isCreatePage
                    || (this.originalDraftData.propertyPromote?.packageCode
                        && this.originalDraftData.propertyPromote?.packageCode === paPackageCode);
            }
            this.isBasePackageSelectionForRelistPage = this.isRelistPage
                && isBasePackageSelection(this.draftData.propertyPromote.packageCode);
            this.priceDisplay = this.isBasePackageSelectionForRelistPage ? 'No charge' : 'Invoiced';
            this.isNewHomeCategory = isNewHomeCategory(this.activatedRoute);
            this.hasIncreasedRV =
                this.originalDraftData.propertyInformation.rateableValue < this.draftData.propertyInformation.rateableValue;
            this.isAgent = isAgentPage(this.activatedRoute);
        });
    }

    usePartnershipAgreement(): boolean{
        return (this.isCreatePage && this.hasPartnershipAgreement)
            || (this.isEditPage && this.paPackageSelected);
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
